<template>
  <div>
    <v-tabs centered v-model="formTab" grow class="non-active-tab-underline">
      <v-tab>{{ fields.formTo.length === 0 ? 'Form fields' : 'First form fields' }}</v-tab>
      <v-tab v-if="fields.formTo.length > 0">Second form fields</v-tab>
    </v-tabs>
    <v-tabs-items v-model="formTab">
      <v-tab-item v-for="form of ['formFrom', 'formTo']" v-bind:key="form">
        <v-data-table
          :class="{ disabled: readOnly }"
          :headers="headers"
          :items="fields[form]"
          item-key="id"
          sort-by="order"
          hide-default-footer
          disable-pagination>
          <template v-slot:item.order="{}" v-if="$rolePermissions.canUpdateWarehouse">
            <v-icon color="black" class="handle" small> mdi-arrow-split-horizontal</v-icon>
          </template>

          <template v-slot:header.sort v-if="false">
            <div class="d-flex">
              <span class="d-inline-block mr-1">Sort</span>
              <help-icon-tooltip>
                The order of how this data displays across the platform. The top two will display on
                the appointment tile in the appointments grid.
              </help-icon-tooltip>
            </div>
          </template>

          <template v-slot:item.field.type="{ item }">
            {{ novaCore.customFieldLabels[item.field.type] }}
          </template>

          <template v-slot:item.label="{ item }">
            {{ item.overrideLabel || item.field.label }}
          </template>

          <template v-slot:item.required="{ item }">
            {{ item.required ? 'Yes' : 'No' }}
          </template>

          <template v-slot:item.actions="{ item }">
            <div class="row-actions">
              <v-icon small color="red">mdi-sort-variant-remove</v-icon>
            </div>
          </template>
        </v-data-table>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
export default {
  props: {
    readOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    warehouse: {
      type: Object,
      required: true
    },
    trigger: {
      type: Object,
      required: true
    }
  },
  computed: {
    headers() {
      return [
        // {
        //   text: 'Sort',
        //   value: 'order',
        //   searchable: false,
        //   sortable: false
        // },
        {
          text: 'Field Label',
          value: 'field.label',
          searchable: true,
          sortable: true
        },
        {
          text: 'Field Type',
          value: 'field.type',
          searchable: true,
          sortable: true
        },
        {
          text: 'Field Description',
          value: 'field.description',
          searchable: true,
          sortable: true
        },
        {
          text: 'Is Required',
          value: 'required',
          searchable: true,
          sortable: true
        }
        // {
        //   text: '',
        //   value: 'actions'
        // }
      ];
    }
  },
  data() {
    return {
      loading: false,
      showFormDialog: false,
      showFormFieldsDialog: false,
      editingForm: null,
      sortBy: ['name'],
      formTab: 'fromFrom',
      fields: {
        formFrom: [],
        formTo: []
      },
      searchFields: ['name', 'description']
    };
  },
  methods: {},
  mounted() {
    Object.entries(this.sockets.actions).map(entry =>
      this.$eventHub.$on(`${entry[0]}-Trigger`, this.getData)
    );

    this.fields.formFrom = this.trigger.flow.formFrom?.formFields || [];
    this.fields.formTo = this.trigger.flow.formTo?.formFields || [];
  },
  beforeDestroy() {
    Object.entries(this.sockets.actions).map(entry => this.$eventHub.$off(`${entry[0]}-Trigger`));
  }
};
</script>
